const constant = {
  prefixList: ["Mr", "Ms", "Miss", "Mrs", "Dr", "Professor"],
  genderList: ["Male", "Female", "Other"],
  phoneTypeList: ["Local", "International"],
  monthList: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  livingAreaList: ["香港", "九龍", "新界"],
};

export { constant };
